import { render, staticRenderFns } from "./DetectionAndTreatmentOfClinicalCases.vue?vue&type=template&id=3a988af1&"
import script from "./DetectionAndTreatmentOfClinicalCases.vue?vue&type=script&lang=js&"
export * from "./DetectionAndTreatmentOfClinicalCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports